<template>
  <div class="map-wrapper">
    <div
      ref="map"
      class="map"
    />
  </div>
</template>

<script>
import Map from 'ol/Map'
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'
import { fromLonLat, transformExtent, transform } from 'ol/proj'
import { markersToLayer, markersToUserLayer, markersToSource, userMarker, updateUserMarker, createMarker } from '../util/maps.js'
import Zoom from 'ol/control/Zoom'

export default {
    name: 'GardenMap',
    props: {
        tileSource: {
            type: String,
            default: 'https://bb209a101d41d7029d4e-93330d88a2f4bfa442606fd6e2955d9a.ssl.cf5.rackcdn.com/garden-map-2018/v1/{z}/{x}/{y}.png'
        },
        center: {
            type: Array,
            default: () => [-73.878024, 40.862188]
        },
        tileExtent: {
            type: Array,
            default: () => [-73.88419, 40.855216, -73.871858, 40.86916]
        },
        viewExtent: {
            type: Array,
            default: () => [-73.87413385212348, 40.867203181431535, -73.88197809943806, 40.85674694343945]
        },
        zoom: {
            type: Number,
            default: 17
        },
        maxZoom: {
            type: Number,
            default: 18
        },
        minZoom: {
            type: Number,
            default: 16
        },
        rotation: {
            type: Number,
            default: 4.71239
        },
        markers: {
            type: Array,
            default: () => []
        },
        debugClick: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            markerLayer: markersToLayer([])
        }
    },
    computed: {
        olMarkers() {
            return this.markers.map(i => {
                console.log(i.exhibitdata.data.marker_icon)
                const m = createMarker(i, this.projection)
                m.set('exhibitdata', i.exhibitdata)
                return m
            })
        },
        userLayer() {
            return markersToUserLayer([this.userMarker])
        },
        userMarker() {
            return userMarker()
        },
        userLocation() {
            return this.$store.state.location
        }
    },
    watch: {
        markers: {
            deep: true,
            immediate: true,
            handler: function() {
                this.refreshMarkers()
            }
        },
        userLocation: function(location) {
            updateUserMarker(this.userMarker, location.coords.latitude, location.coords.longitude)
        }
    },
    mounted() {
        this.map = new Map({
            target: this.$refs.map,
            controls: [
                new Zoom()
            ],
            layers: [
                new TileLayer({
                    extent: transformExtent(this.tileExtent, 'EPSG:4326', 'EPSG:3857'),
                    source: new XYZ({
                        url: this.tileSource,
                        tilePixelRatio: 1.000000,
                        minZoom: this.minZoom,
                        maxZoom: this.MaxZoom
                    })
                }),
                this.markerLayer,
                this.userLayer
            ],
            view: new View({
                extent: transformExtent(this.viewExtent, 'EPSG:4326', 'EPSG:3857'),
                center: fromLonLat(this.center),
                zoom: this.zoom,
                minZoom: this.minZoom,
                maxZoom: this.maxZoom,
                rotation: this.rotation
            })
        })
        this.map.on('click', (e) => {
            if (this.debugClick) {
                const lonlat = transform(e.coordinate, 'EPSG:3857', 'EPSG:4326')
                console.log('Map clicked at', lonlat)
            }
            // Enumerate any features under the mouse and emit a Vue event with the
            // first found feature
            const clicked = e.map.forEachFeatureAtPixel(e.pixel, (f) => f)
            clicked && this.$emit('feature-click', clicked)
        })
    },
    activated() {
        // Resize the map when this view is reactivated (if it's keepalive)
        this.map.updateSize()
    },
    methods: {
        refreshMarkers() {
            console.log(this.olMarkers)
            this.markerLayer.setSource(markersToSource(this.olMarkers))
        }
    }
}
</script>

<style lang="scss" scoped>
.map-wrapper {
    position: relative;
    @include flex-vertical;
    @include flex-fill-vertical;
}
.map {
    @include flex-fill-vertical;
}
</style>